/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {isRejectedWithValue} from '@reduxjs/toolkit';
import type {Middleware} from '@reduxjs/toolkit';
import {toast} from 'react-toastify';
import {logout} from 'src/redux/features/usuarioSlice';

const endPonitsIgnore404 = ['getConsultorByIdProyecto', 'getAdministradorByIdProyecto', 'obtenerPlantillaDeMensajeParaProyectoYTipo', 'obtenerUsuarioUnidad'];

const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
	if (isRejectedWithValue(action)) {
	  const errorMessage = action.payload.data?.details || action.payload.data?.message || action.payload?.details || action.data?.details  || JSON.stringify(action.payload) || 'Error desconocido';
	  switch (action.payload.status) {
		case 401:
		  localStorage.clear();
		  next(logout());
		  localStorage.clear();
		  toast.dismiss();
		  toast.error(errorMessage || 'No autorizado');
		  break;
		case 403:
		  toast.dismiss();
		  next(logout());
		  localStorage.clear();
		  toast.error(errorMessage || 'Acceso denegado');
		  break;
		case 404:
		  if (!endPonitsIgnore404.includes(action.meta.arg.endpointName)) {
			toast.dismiss();
			toast.error(errorMessage || 'No encontrado');
		  }
		  break;
		case 500:
		  toast.dismiss();
		  toast.error(errorMessage || 'Error interno del servidor');
		  break;
		default:
		  toast.dismiss();
		  toast.error(errorMessage);
	  }
	}
	return next(action);
  };
  
  export default rtkQueryErrorLogger;
